export const INITIAL_CONTEXT = {
  isOpen: false,
  setOpen: () => null,
  data: null,
  setData: () => null,
};
